<template>
	<div class="full">
		<el-descriptions title="" border size="mini" :column="4">
			<el-descriptions-item label="发票金额">{{description.totalPrice}}</el-descriptions-item>
			<el-descriptions-item label="采购金额">{{description.stockamount}}</el-descriptions-item>
			<el-descriptions-item label="差额">{{(description.totalPrice - description.stockamount).toFixed(4)}}</el-descriptions-item>
			<el-descriptions-item label="自动分配金额">
				<el-switch v-model="description.distribution" active-color="#13ce66" inactive-color="#ff4949" @change="distributionChange"></el-switch>
			</el-descriptions-item>
		</el-descriptions>
		<vxe-grid ref="initinputinvoiceorderTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="tab" @modalhide="invoiceConfigHide" />
		<editcargo-Form ref="editcargoForm" :goodsUids="goodsUids" :currentrow="currentrow" @submit="editcargoSubmit" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import invoiceConfig from '../../invoice/index.vue'
	import editcargoForm from '../../goodsspu/editcargo.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				step: 1,
				invoicedata:[],
				tab:[],
				goodsUids:[],
				currentrow:null,
				batchcurrentrow:[],
				modal_model: true,
				modal_title: '生成亿企赢单据',
				modal_width: 1200,
				modal_height: 800,
				list_autorender:false,
				list_footerField:[
					{field:'size',toFixed:4},
					{field:'stockamount',toFixed:4},
				],
				description:{
					totalPrice:0,
					stockamount:0,
					distribution:true,
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			sourcefile(row) {
				this.invoicedata = {
					invoiceNumber:row.invoiceNumber,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					orderId:row.orderId,
					orderPlant:row.orderPlant,
					invoiceType:1
				}
				this.tab = ['invoice','detail']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			invoiceConfigHide(){
				this.customreload()
			},
			cargoconfig(row){
				// if(!row.goodsUid){
				// 	this.$message.error('暂无商品信息，请手动输入')
				// 	return
				// }
				this.currentrow = row
				this.batchcurrentrow = []
				if(row.goodsUid){
					this.goodsUids = [row.goodsUid]
				}else{
					this.goodsUids = null
				}
				
				this.$nextTick(()=>{
					this.$refs.editcargoForm.modal_show()
				})
			},
			batchcargoconfig(){
				let data = this.$refs.initinputinvoiceorderTable.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.currentrow = null
				this.batchcurrentrow = data
				this.goodsUids = null
				this.$nextTick(()=>{
					this.$refs.editcargoForm.modal_show()
				})
				
			},
			editcargoSubmit(e){
				if(this.currentrow){
					this.currentrow.cargoName = '*' + window.systemMethods.getEmunValue('cargotype',e.cargotype) + '*' + e.cargoname
				}
				if(this.batchcurrentrow.length){
					this.batchcurrentrow.forEach((item)=>{
						item.cargoName = '*' + window.systemMethods.getEmunValue('cargotype',e.cargotype) + '*' + e.cargoname
					})
				}
				this.currentrow = null
				this.batchcurrentrow = []
				//this.customreload()
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.height = 550
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				},{
					name: '批量设置存货',
					status: 'primary',
					code: 'batchcargoconfig'
				}]
				gridOptions.columns = [{
						type: 'checkbox',
						title: '',
						width:50
					},{
						type: 'seq',
						title: '#',
						width:50
					},
					// {
					// 	field: 'billcode',
					// 	title: '单据编码',
					// 	sortable:true,
					// },
					{
						field: 'goodsName',
						title: '商品名称',
						sortable:true,
					},
					{
						field: 'cargoName',
						title: '存货名称',
						sortable:true,
						editRender: {
							name: '$input',
							props: {
								readonly:true,
								quote: false
							},
							events: {
						
							}
						},
					},
					{
						field: 'spec',
						title: '规格型号',
						editRender: {
							name: '$input',
							props: {
								quote: false
							},
							events: {
						
							}
						},
					},	
					{
						field: 'unit',
						title: '单位',
						editRender: {
							name: '$input',
							props: {
								quote: false
							},
							events: {
						
							}
						},
					},					
					{
						field: 'size',
						title: '数量',
						editRender: {
							name: '$input',
							props: {
								quote: false
							},
							events: {
						
							}
						},
					},
					{
						field: 'stockamount',
						title: '入库金额',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:4,
								quote: false
							},
							events: {
						
							}
						},
					},
					{
						field: 'inboundtype',
						title: '入库方式',
						editRender: {
							name: '$select',
							props: {
								selectoptions: [{
									value:'1',
									label:'普通入库'
								},{
									value:'2',
									label:'冲抵存货'
								}]
							},
							events: {
						
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 100,
						slots: {
							default: ({row}) => {
								return [									
									<el-button type = "text" size = "mini" onClick = {() => {this.cargoconfig(row)}}>存货</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.remove(row)}}>删除</el-button>
									
								]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					cargoName: [{
						required: true,
						message: '缺少必填项【存货名称】',
					}],
					stockamount: [{
						required: true,
						message: '缺少必填项【入库金额】',
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					this.$api.invoice.initinputinvoiceorder({
						invoiceNumber: this.data.invoiceNumber,
					}).then((res) => {
						this.loading = false
						res.list.forEach((item)=>{
							item.sourcestockamount = item.stockamount
							item.inboundtype = item.inboundtype ? item.inboundtype :'1'
						})
						this.description.totalPrice = this.$Lodash.sumBy(this.store.invoicelist,(item)=>{
							return parseFloat(item.totalPrice)
						})
						this.description.totalPrice = this.description.totalPrice.toFixed(4)
						this.description.stockamount = this.$Lodash.sumBy(res.list,(item)=>{
							return parseFloat(item.stockamount)
						})
						this.description.stockamount = this.description.stockamount.toFixed(4)
						this.distribution(res.list)
						resolve(res)
					},()=>{
						this.loading = false
					})
				})
			},
			distributionChange(){
				this.distribution()
			},
			distribution(data){
				if(!data){
					data = this.$refs.initinputinvoiceorderTable.getTableData().visibleData
				}
				let sourcestockamount = this.$Lodash.sumBy(data,(item)=>{
					return parseFloat(item.sourcestockamount)
				})
				if(!this.description.distribution){
					data.forEach((item)=>{
						item.stockamount = item.sourcestockamount
					})
				}else{
					data.forEach((item)=>{
						item.stockamount = parseFloat(item.sourcestockamount) + item.sourcestockamount/sourcestockamount * (this.description.totalPrice - this.description.stockamount)
						item.stockamount = item.stockamount.toFixed(6)
					})
				}
				this.$refs.initinputinvoiceorderTable.updateFooter()
				//console.log(data,123123)
			},
			valid(){
				let data = this.$refs.initinputinvoiceorderTable.getTableData().visibleData
				let cargoNameBuff = false
				for(let i =0 ;i<data.length;i++){
					if(!data[i].cargoName){
						cargoNameBuff = data[i]
						break;
					}
				}
				if(cargoNameBuff){
					this.$refs.initinputinvoiceorderTable.scrollToRow(cargoNameBuff)
				}
				this.store.initinputinvoiceorder = data
				return cargoNameBuff
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			},
			customreload() {
				this.$refs.initinputinvoiceorderTable.commitProxy('query')
			},
			add(){
				this.$refs.initinputinvoiceorderTable.insert({inboundtype:'1',stockamount:0,id:Math.random()})
			},
			remove(row){
				this.$refs.initinputinvoiceorderTable.remove(row)
			}
		},
		components: {
			invoiceConfig,
			editcargoForm
		}
	}
</script>